import PropTypes from "prop-types";

import styles from "./WizardSection.module.scss";
import { CustomContainer } from '../../atoms/DependencyHelper';

const WizardSection = (props) => (
  <CustomContainer className={styles["wizard-section-container"]}>
    <div className={styles["section-indicators"]}>
      { !props.isLast && <span className={styles["indicator-line"]}/>}

      { !props.showAsSubsection
        ? <span className={styles["section-step"]}>{props.stepNumber}</span>
        : <span className={styles["section-sub-step"]} />
      }
    </div>
    
    <div className={styles["section-content"]}>
      <div className={styles["section-header"]}>
        <h5
          className={props.showAsSubsection
            ? styles["subsection-header"]
            : styles["section-header"]
          }>
          { props.sectionTitle }
          { props.isOptional && <span className={`${styles["addOns-grey"]}`}>(Optional)</span> }
        </h5>
      </div>

      <div className={styles["section-body"]}>
        {props.children}
      </div>
    </div>
  </CustomContainer>
);

WizardSection.propTypes = {
  children: PropTypes.node.isRequired,
  sectionTitle: PropTypes.string.isRequired,
  showAsSubsection: PropTypes.bool,
  stepNumber: PropTypes.number,
  isLast: PropTypes.bool,
  isOptional: PropTypes.bool,
  isSectionHidden: PropTypes.bool, // Note: Prop used in SummeryWizard
}

WizardSection.defaultProps = {
  showAsSubsection: false,
  isLast: false,
  isSectionHidden: false,
}

export default WizardSection;
